import {
  ActiveDiscontRequest,
  ActiveDiscontResponse,
  CreateFirstDiscontRequest,
  CreateFirstDiscontResponse,
  DISCONTS,
  DISCONTS_ACTIVE,
  DISCONTS_FIRST,
  GetDiscontsRequest,
  GetDiscontsResponse,
} from "@project/shared-types";
import apiFetchPost from "../../../api/apiClient";

export const getDiscontsAPI = async () => {
  try {
    const response = await apiFetchPost<
      GetDiscontsRequest,
      GetDiscontsResponse
    >(DISCONTS, {});
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const activeDiscontAPI = async (discont_id: string, active: boolean) => {
  try {
    const response = await apiFetchPost<
      ActiveDiscontRequest,
      ActiveDiscontResponse
    >(DISCONTS_ACTIVE, { discont_id, active });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createFirstDiscontAPI = async (email: string) => {
  try {
    const response = await apiFetchPost<
      CreateFirstDiscontRequest,
      CreateFirstDiscontResponse
    >(DISCONTS_FIRST, { email });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
